import { Component, OnInit } from '@angular/core';
import { ManageTemplateWrapper } from './manage-template-wrapper';
import { exhibitorTemplateReselector } from '../../store/reselectors/entity.reselector';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { ManageWrapperComponent } from 'src/app/modules/manage/manage-wrapper.component';
import { CommonModule } from '@angular/common';
import { ImageUploaderComponent } from '../wrappers/image-uploader.component';
import { ManageSocialLinksComponent } from 'src/app/modules/manage/manage-social.component';
import { ManageContactDetailsComponent } from 'src/app/modules/manage/manage-contact-details.component';
import { ManageCallToActionComponent } from 'src/app/modules/manage/manage-call-to-action.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';

@Component({
    selector: 'manage-template-exhibitor',
    templateUrl: './manage-template-exhibitor.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, CommonModule, ImageUploaderComponent, JoiInputComponent, ManageSocialLinksComponent, ManageContactDetailsComponent, ManageCallToActionComponent],
})
export class ManageTemplateExhibitor extends ManageTemplateWrapper<Exhibitor> implements OnInit {
  _file = 'manage-template-exhibitor'

  ngOnInit() {
    this.clipboardKey = 'exhibitors'
    this.selectProp(exhibitorTemplateReselector, { id: this.data.entityId, accountId: this.data.accountId }, 'entity')
  }


}
